import { Injectable } from '@angular/core';
import { DTypeCol, DTypeRepository, DTypeStatus, NextLocator } from '@grupo-constant/next-dtype/types';
import { catchError, map, Observable, throwError } from 'rxjs';
import { DTypeService } from '../dtype/dtype.service';
import { Complex } from './complex.types';

export const COMPLEX_URI = 'dtype://com.cloudcodice.feature.dtype.complex.Complex';

@Injectable({
    providedIn: 'root'
})
export class ComplexService {

    constructor(private dtypeService: DTypeService) { }

    retrieveComplexDType() {
        return this.dtypeService.getDatatype({ retrieveDTypeBody: { uri: COMPLEX_URI, status: DTypeStatus.DESIGN, bindableOptions: true }, includeEmbedded: true });
    }

    retrieveComplexDTypeByUri(uri: string, status: DTypeStatus, locator?: NextLocator): Promise<Complex> {
        return this.dtypeService.getDatatype({ retrieveDTypeBody: { uri, status, locator, bindableOptions: true }, includeEmbedded: true });
    }

    retrieveComplexDTypeRepositoryByUri(uri: string, status: DTypeStatus, locator?: NextLocator): Observable<DTypeRepository> {
        return this.dtypeService.retrieveDTypeRepositoryByUri({ uri, status, locator, bindableOptions: true });
    }

    retrieveComplexDtypeForm(values: any, options?: { readonly?: boolean; isUpdate?: boolean }) {
        return this.dtypeService.getDtypeFormByUri({ uri: COMPLEX_URI, status: DTypeStatus.DESIGN, bindableOptions: true }, values, options);
    }

    flushComplex(complex: Complex, locator: NextLocator, goLive?: boolean) {
        return this.dtypeService.flushDType({ locator, facadeUri: COMPLEX_URI, dtype: complex })
            .pipe(
                catchError((error) => {
                    console.error(error);
                    return throwError(() => error.error);
                }),
                map(reply => reply.repository)
            );
    }

    updateComplex(repo: DTypeRepository, goLive?: boolean) {
        this.dtypeService.updateDType(repo.uri, repo, goLive);
    }

    emitUpdateSidebarEvent() {
        this.dtypeService.emitUpdateSidebarEvent();
    }

    updateColumns(columns: DTypeCol[]) {
        this.dtypeService.columns$.next(columns);
    }

    getLocatorFromString(stringLocator: string): NextLocator {
        return this.dtypeService.getLocatorFromString(stringLocator);
    }

}
